import { useAtomValue } from 'jotai'
import React from 'react'

import { type Brand } from '~/hooks/useSurveyQuery'
import { exists } from '~/utils'

import { segmentDisplayTypeAtom, tabulationQueryDataAtom } from '../atoms'

import { FiveSegmentsTable } from './FiveSegmentsTable'
import { NineSegmentsTable } from './NineSegmentsTable'
import styles from './StandardAnalysisTable.css'

export type StandardAnalysisTableProps = {
  brand: Brand
}

export const StandardAnalysisTable = ({
  brand,
}: StandardAnalysisTableProps) => {
  const tabulationQueryData = useAtomValue(tabulationQueryDataAtom)
  const segmentDisplayType = useAtomValue(segmentDisplayTypeAtom)

  if (!exists(tabulationQueryData)) {
    return null
  }

  return segmentDisplayType === 'fiveSegs' ? (
    <FiveSegmentsTable brand={brand} className={styles.table} />
  ) : (
    <NineSegmentsTable brand={brand} className={styles.table} />
  )
}
